import merLogo from "@/assets/case-studies/mer-logo.svg";
import mer1 from "@/assets/shop/mer-1.avif";
import mer2 from "@/assets/shop/mer-2.avif";
import mer3 from "@/assets/shop/mer-3.avif";
import mer4 from "@/assets/shop/mer-4.avif";
import coterieLogo from "@/assets/shop/coterie-logo.svg";
import coterie1 from "@/assets/shop/coterie-1.jpeg";
import coterie2 from "@/assets/shop/coterie-2.jpg";
import coterie3 from "@/assets/shop/coterie-3.jpg";
import coterie4 from "@/assets/shop/coterie-4.jpg";
import coterie5 from "@/assets/shop/coterie-5.jpg";

export interface ShopTemplate {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  images: string[];
  logo: string;
  price: number;
  priceDisplay: string;
  livePreviewUrl: string;
  purchaseUrl: string;
  features: string[];
  category: string;
  platform: string;
  caseStudyUrl?: string;
}

export const templates: ShopTemplate[] = [
  {
    slug: "mer",
    title: "MĒR",
    subtitle: "Restaurant & Bar Template",
    description:
      "A refined Framer template built for restaurants, bars, and food & beverage brands. Designed with editorial restraint — structured menus, reservation-ready layouts, and a CMS your team can manage without a designer on call.",
    images: [mer1, mer2, mer3, mer4],
    logo: merLogo,
    price: 40,
    priceDisplay: "$40",
    livePreviewUrl: "https://mer.framer.website/",
    purchaseUrl: "https://contra.com/payment-link/Y05MAncr-mer-stunning-eatery-template",
    features: [
      "Fully responsive design",
      "CMS-powered menu system",
      "Reservation / contact integration",
      "Events & specials section",
      "SEO-optimized structure",
      "Easy brand customization",
    ],
    category: "Food & Beverage",
    platform: "Framer",
  },
  {
    slug: "coterie",
    title: "Coterie",
    subtitle: "Real Estate Industry Template",
    description:
      "A modern, refined Framer template built for real estate professionals who want a website that feels as polished as the properties they represent. Complete CMS control over listings, community pages, and room styles — your team updates everything without touching a single line of code.",
    images: [coterie2, coterie3, coterie4, coterie5],
    logo: coterieLogo,
    price: 65,
    priceDisplay: "$65",
    livePreviewUrl: "https://coterie.framer.website/",
    purchaseUrl: "https://contra.com/payment-link/D8Ql5hHf-coterie-real-estate-industry-template",
    features: [
      "Full CMS control over all content",
      "Listings & property pages",
      "Community & room styles pages",
      "A11y optimized & responsive",
      "Custom cursors & animations",
      "Automated SEO & analytics",
    ],
    category: "Real Estate",
    platform: "Framer",
    caseStudyUrl: "/shop/coterie",
  },
];

export const allCategories = [...new Set(templates.map((t) => t.category))];
export const allPlatforms = [...new Set(templates.map((t) => t.platform))];
export const priceRanges = [
  { label: "Under $50", min: 0, max: 49 },
  { label: "$50 – $100", min: 50, max: 100 },
  { label: "$100+", min: 100, max: Infinity },
] as const;
